import { render, staticRenderFns } from "./SecSafety_SKMA.vue?vue&type=template&id=9a9661d6&scoped=true&"
import script from "./SecSafety_SKMA.vue?vue&type=script&lang=js&"
export * from "./SecSafety_SKMA.vue?vue&type=script&lang=js&"
import style0 from "./SecSafety_SKMA.vue?vue&type=style&index=0&id=9a9661d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9661d6",
  null
  
)

export default component.exports